import { getAsset } from "@/helpers/assetsUtils";

export const getContactInfo = () => {
    return Promise.resolve([
        {
            country: 'GER',
            flag: getAsset('icons', 'flag-german.svg'),
            phone: ' +49 89 370 40 571'
        },
        {
            country: 'UK',
            flag: getAsset('icons', 'flag-uk.svg'),
            phone: '+44 20 376 92 931'
        },
        {
            country: 'USA',
            flag: getAsset('icons', 'flag-usa.svg'),
            phone: '+1 646 814 3217'
        }
    ]);
};